import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _NationalizationProcessItems } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectTHConstantsValue } from "../../../../config/Componentes/SelectTHConstantsValue";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PaymentMethodSelect } from "../../../../../Talentohumano/PaymentMethod/PaymentMethodSelect";
import { SelectorUmeasurement } from "../../../../config/Componentes/SelectorUmeasurement";

interface Props {
    IDNationalizationProcessGeneralInfo: number;
}


export const NationalizationProcessItemsByActStore = ({ IDNationalizationProcessGeneralInfo }: Props) => {

    const ByActStore = useDataBean(_NationalizationProcessItems);
    const single = Singleton.getInstance();
    const [Type, setType] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDNationalizationProcessGeneralInfo])

    const getLista = () => {

        ByActStore.instance.getNationalizationProcessItemsRender(IDNationalizationProcessGeneralInfo).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        ByActStore.setBean({
            IDNationalizationProcessGeneralInfo: IDNationalizationProcessGeneralInfo,
            ItemType: ByActStore.bean.ItemType,
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ByActStore.deleteItemVoid(ByActStore.bean.IDNationalizationProcessItems).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }


    const editaItem = () => {
        //console.log(entailment.bean);
        ByActStore.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const head = [
        { title: 'ID', property: 'IDNationalizationProcessItems', visible: true },
        // { title: 'Tipo de  Item / Lote', property: 'ItemType', visible: true },
        // { title: 'Consecutivo de registro', property: 'Item', visible: true },
        { title: 'Lote', property: 'LoteNumber', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Valor Unitario', property: 'UnitValueEM', visible: true, mask: MASK_MONEY },
        // { title: 'Valor Total FOB', property: 'TotalValueFOBEM', visible: true },
        // { title: 'Fletes', property: 'TransportCostEM', visible: true },
        // { title: 'Seguros', property: 'InsuranceEM', visible: true },
        // { title: 'Valor Total CIF', property: 'TotalValueCIFEM', visible: true },
        // { title: 'Valor Total COP', property: 'TotalValueCOPEM', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "name": `Editar ${ByActStore.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Items">
            <div className="row">
                {/* <div className="col-md-6">
                    <label>Tipo de  Item / Lote</label>
                    <SelectTHConstantsValue code={602} value={Type} onChange={(e: any) => { setType(e) }}></SelectTHConstantsValue>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar por Item / Lote</BasicButton>
                </div> */}
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ByActStore.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                <label>Tipo de  Item / Lote</label>
                                <SelectTHConstantsValue code={602} value={ByActStore.bean.ItemType} onChange={(e: any) => { ByActStore.setBean({ ...ByActStore.bean, "ItemType": e }) }}></SelectTHConstantsValue>
                            </div> */}
                            {/* <div className="col-md-6">

                                <label>No.Consecutivo de registro item</label>
                                <input type="text" name="Item" className="form-control" value={ByActStore.bean.Item} onChange={ByActStore.handleChange} />

                            </div> */}
                            <div className="col-md-6">

                                <label>No. Lote</label>
                                <input type="text" name="LoteNumber" className="form-control" value={ByActStore.bean.LoteNumber} onChange={ByActStore.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Cantidad</label>
                                <input type="text" name="Quantity" className="form-control" value={ByActStore.bean.Quantity} onChange={ByActStore.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <SelectorUmeasurement titulo='Unidad de Medida' idSelector={ByActStore.bean.MeasureUnitEM} onChange={(e) => { ByActStore.setBean({ ...ByActStore.bean, "MeasureUnitEM": e }) }} />
                            </div>
                            <div className="col-md-6">

                                <label>Valor Unitario</label>
                                <input type="text" name="UnitValueEM" className="form-control" value={ByActStore.bean.UnitValueEM} onChange={ByActStore.handleChange} />

                            </div>
                            {/* <div className="col-md-6">

                                <label>Valor Total FOB</label>
                                <input type="text" name="TotalValueFOBEM" className="form-control" value={ByActStore.bean.TotalValueFOBEM} onChange={ByActStore.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Fletes</label>
                                <input type="text" name="TransportCostEM" className="form-control" value={ByActStore.bean.TransportCostEM} onChange={ByActStore.handleChange} />

                            </div> */}
                            <div className="col-md-6">

                                <label>Seguro</label>
                                <input type="text" name="InsuranceEM" className="form-control" value={ByActStore.bean.InsuranceEM} onChange={ByActStore.handleChange} />

                            </div>
                            {/* <div className="col-md-6">

                                <label>Valor Total CIF</label>
                                <input type="text" name="TotalValueCIFEM" className="form-control" value={ByActStore.bean.TotalValueCIFEM} onChange={ByActStore.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Valor Total COP</label>
                                <input type="text" name="TotalValueCOPEM" className="form-control" value={ByActStore.bean.TotalValueCOPEM} onChange={ByActStore.handleChange} />

                            </div> */}
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={ByActStore.bean.Description} onChange={ByActStore.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ByActStore.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}